import React, { useEffect, useRef, useState } from 'react'
import { Access, connect, FormattedMessage, history, SelectLang, useAccess, useIntl, useModel } from 'umi'
import type { FormInstance} from 'antd'
import FormItem from 'antd/lib/form/FormItem'
import type { LabeledValue } from 'antd/lib/select'
import ProForm, { ModalForm, ProFormCaptcha, ProFormText } from '@ant-design/pro-form'
import { Avatar, Button, Input, message, Modal, Space, Typography, Upload, Tooltip, Select } from 'antd'
import { EyeInvisibleOutlined, EyeTwoTone, MobileOutlined, PhoneOutlined, PlusOutlined, UploadOutlined } from '@ant-design/icons'

import V from '@/utils/validator'
import { FILE_PATH } from '@/constant'
import type { SearchMenu } from '@/app'
import {getSetting, uploadFile} from '@/services/basic'
import DoubleCallModal from "@/components/DoubleCallModal";
import { getNations } from '@/pages/Customer/AddCustomer/service';
import {getLocale, setLocale} from "@@/plugin-locale/localeExports";
import type {  UserFormParams } from '@/pages/System/EmployerManage/data'
import type { NationType } from '@/pages/Customer/AddCustomer/data.d';
import LocaleModifyComp, { mapToLocationStateProps } from '@/components/LocaleModifyComp'
import MenuSearch from '../MenuSearch'
import MessageCenter from '../MessageCenter'
import InquiryDropdown from '../Inquiry/InquiryDropdown'
import type { LayoutContentWrapProps } from '../LayoutContentWrap'
import MessageNotice from './MessageNotice'
import AvatarDropdown, { loginOut } from './AvatarDropdown'
import type { ForceChangePwdParams, ResetPwdParams, UpdateRoleInfoParams } from './data.d'
import { fetchLanguageList, forceChangePwd, getCaptchaByPhone, pwdChange, updateRoleInfo } from './service'
import styles from './index.less'
export type SiderTheme = 'light' | 'dark';

const defaultPwdPattern = /^(?=.*\d)(?=.*[a-zA-Z])(?!.*[\u4e00-\u9fa5]).{6,}$|^(?=.*\d)(?=.*[^\s\da-zA-Z])(?!.*[\u4e00-\u9fa5]).{6,}$|^(?=.*[^\s\da-zA-Z])(?=.*[a-zA-Z])(?!.*[\u4e00-\u9fa5]).{6,}$/;

const GlobalHeaderRight: React.FC<LayoutContentWrapProps> = ({
  dispatch,
}) => {
  // 国际化
  const intl = useIntl();
  const c = window.$tc('', intl.formatMessage);
  const t = window.$tc('component.GlobalHeaderRight.index', intl.formatMessage);

  // 编辑个人信息、修改密码
  const access = useAccess();
  const formRef = useRef<FormInstance>();
  const formRefChange = useRef<FormInstance>();
  const [userUpdateVisible, setUserUpdateVisible] = useState<boolean>(false)
  const [pwdRestVisible, setPwdRestVisible] = useState<boolean>(false)
  const [inputPassword, setInputPassword] = useState<string>('')
  const [avatarTempUrl, setAvatarTempUrl] = useState<string>('')
  const [avatarFile, setAvatarFile] = useState<File | undefined>()

  // 帮助文档
  const [rightContentVisible, setRightContentVisible] = useState<boolean>(true)
  // 强制修改用户信息
  const [codeId, setCodeId] = useState<string>();
  const { initialState, setInitialState } = useModel('@@initialState');
  const [ initialValues, setInitialValues ] = useState<any>();
  const [pwdPattern,setPwdPattern]=useState(defaultPwdPattern)
  const [ruleMsg,setRulemsg]=useState(c('component.GlobalHeaderRight.index.t43', "注：密码长度需大于6位（含），支持输入字母、数字和字符，且必须包含2项以上。设置成功后需重新登录。"))
  const getPwdPattern= async ()=>{
    const res =await getSetting({confKey:'tenant:user-password-settings'})

    if(res.code===200){
      setPwdPattern(new RegExp(res.data.confValue))
    }
  }
  useEffect(()=>{
    getPwdPattern()
  },[])


  useEffect(()=>{
    const { mobile } = initialState?.currentUser || {}
    if (mobile) {
      const arr = mobile.split('-')
      if (arr.length == 1) {
        Object.assign(initialState?.currentUser,{
          areaCode: "86",
          mobile
        })
        setAreaCode("86")
      } else {
        Object.assign(initialState?.currentUser,{
          areaCode: arr[0],
          mobile: arr[1]
        })
        setAreaCode(arr[0])
      }
    }
    setInitialValues(initialState?.currentUser)
  },[initialState])
  useEffect(()=>{
    formRefChange.current?.resetFields()
    formRefChange.current?.validateFields(['mobile'])
  },[initialValues])
  // 国家区号列表
  const [areaCodeList, setAreaCodeList] = useState<NationType[]>([]);
  const [areaCode, setAreaCode] = useState<string>('86');
  useEffect(()=>{
    const lang= getLocale()
    sessionStorage.setItem('umi_locale',lang)
    // 获取国家区号列表
    getNations().then(({code,data})=>{
      if (code === 200) {
        const areaCodeList = data.list.map((item: NationType)=>{
          return {
            label:"+" + item.callingCode,
            value:item.callingCode,
          }
        })
        setAreaCodeList(areaCodeList);
      }
    })
  },[])
  // 联系电话校验，首先校验手机格式，再校验固话
  const [mobileSuffix, setMobileSuffix] = useState<React.ReactNode>();
  const mobileValidator = () => {
    const { areaCode, mobile } = formRefChange.current?.getFieldsValue(['areaCode','mobile']);
    if (areaCode != '86') {
      setMobileSuffix(undefined);
      if (mobile) {
        return Promise.resolve();
      }
    }
    if (V.mobile(mobile)) {
      setMobileSuffix(<MobileOutlined />);
      return Promise.resolve();
    } else if (V.telephone(mobile)) {
      setMobileSuffix(<PhoneOutlined />);
      return Promise.resolve();
    }
    setMobileSuffix(undefined);
    return Promise.reject(new Error(t('t47', '请输入正确格式的联系电话')));
  };
  const mobileValidatorEdit = () => {
    const { areaCode, mobile } = formRef.current?.getFieldsValue(['areaCode','mobile']);
    if (areaCode != '86') {
      setMobileSuffix(undefined);
      if (mobile) {
        return Promise.resolve();
      }
    }
    if (V.mobile(mobile)) {
      setMobileSuffix(<MobileOutlined />);
      return Promise.resolve();
    } else if (V.telephone(mobile)) {
      setMobileSuffix(<PhoneOutlined />);
      return Promise.resolve();
    }
    setMobileSuffix(undefined);
    return Promise.reject(new Error(t('t47', '请输入正确格式的联系电话')));
  };

  const [initIntlSucceed, setInitIntlSucceed] = useState(false);
  // 获取数据库语言配置，更新 intl.messages
  const updateIntlMessages = async () => {
    try {
      const { code, data } = await fetchLanguageList();
      if (code === 200) {
        setInitIntlSucceed(true);
        data?.forEach((item: Record<string, any>) => {
          intl.messages[item.code] = item.value;
        });
      }
    } catch (err) {
      console.log(err);
    }
  }
  // 更新 intl 并刷新页面重新渲染
  const getLanguageList = async () => {
    await updateIntlMessages();
    /** BUG 3027
     * 原因：在 updateIntlMessages() 请求完成后，需要修改 intl 信息并重新加载页面。updateIntlMessages() 请求数据过程中（英文翻译文件比较大，请求时间较长），如果用户点击了其他路由并进行了跳转，则路由数量为 2，且 currentIndex 值为 1，
     * 请求完成后，执行 dispatch: locationState/reloadPage 操作，此时 payload 设置为 0，会导致 locationState.refreshIndex 更新，触发 LayoutContentWrap 组件重新加载 tabList[0] 路由，因此出现 BUG 3027
     * 解决办法：设置 payload: 9999，且在组件 LayoutContentWrap 中对 refreshIndex 的值做判断处理，如果是 9999 则使用 headerContentTabList.tabList 中最后一个路由进行页面的重新加载
     */
    dispatch({ type: 'locationState/reloadPage', payload: 9999 });
  };
  // // 国际化--语言切换后重新获取路由信息
  // const [lang, setLang] = useState(getLocale());
  // const selectedLang = getLocale();
  // const refreshMenus = async () => {
  //   const permissionMenus = await fetchPermissionMenus();
  //   const accessibleRoutes: Record<string, string> = {};
  //   const searchMenus: LabeledValue[] = [];
  //   const menus = convertMenus(permissionMenus, accessibleRoutes, searchMenus);
  //   setInitialState({
  //     ...initialState,
  //     collapsed: initialState?.collapsed as boolean,
  //     accessibleRoutes,
  //     menus,
  //     searchMenus,
  //   })
  // // eslint-disable-next-line react-hooks/exhaustive-deps
  // };
  // useEffect(() => {
  //   console.log('%c===== 语言: ' + selectedLang + ' =====', 'color:red');
  //   console.log(lang === selectedLang);
  //   if (lang === selectedLang) return;
  //   refreshMenus();
  //   setLang(selectedLang);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [selectedLang]);

  //设置弹窗
  //帮助文档
  // localStorage.removeItem('RightContentVisible')
  //判断本地里有没有存值 如果有的话就代表已经弹过弹窗  无需再提示 否则就提示并把值存到本地
  useEffect(() => {

    if (localStorage.getItem('RightContentVisible')) {
      setRightContentVisible(false)
    } else {
      setTimeout(()=>{
        setRightContentVisible(false);
        localStorage.setItem('RightContentVisible','RightContentTooltip')
      }, 5000)
    }

    // 获取前端i18n语言配置列表
    getLanguageList();
  }, []);

  // 站内搜索
  const [searchedMenus, setSearchedMenus] = useState<LabeledValue[]>();

  if (!initialState || !initialState.settings) {
    return null;
  }
  const { navTheme, layout } = initialState.settings;
  let className = styles.right;
  if ((navTheme === 'dark' && layout === 'top') || layout === 'mix') {
    className = `${styles.right}  ${styles.dark}`
  }

  // 更新用户信息
  const handleUpdateUser = async (fields: UpdateRoleInfoParams) => {
    const hide = message.loading(t('t0', '正在更新'))
    try {
      const { code, msg} = await updateRoleInfo({ ...fields })
      hide()
      if (code === 200) {
        // const loginExtra = {
        //   platform: 1, // 固定web平台
        //   domain
        // }
        // if (userInfo) {
        //   userInfo.elements = initialState.currentUser?.elements
        //   setInitialState({
        //     ...initialState,
        //     currentUser: { ...loginExtra, ...userInfo }
        //   })
        // }
        message.success('更新用户信息成功')
        window.location.reload()
        return true
      }
      message.error(msg)
      return false
    } catch (error) {
      hide()
      message.error(t('t1', '更新用户信息失败请重试！'))
      return false
    }
  }
  const handleItemClick=(params: {key: string})=>{
    const lang=sessionStorage.getItem('umi_locale') || ''
    const localeLang=getLocale() || ''
    setLocale(params.key)
    if(params.key===localeLang && lang !== localeLang){
      window.location.reload();
    }
  }
  // 重置密码

  return (
    <Space className={className} size={0} >
      <Access accessible={access['hm-help-doc']}>
        <a href="https://help.lanxi.com/" target="_blank" rel="noreferrer">
          <Tooltip
            title={(
              <div style={{ whiteSpace: 'break-spaces' }}>
                {t('t5', "查看帮助文档，快速熟悉系统")}
              </div>
            )}
            color="blue"
            placement="bottom"
            open={rightContentVisible}
            getPopupContainer={node => node}
            // overlayInnerStyle={styles.helpDocument}
          >
            <Button
              className={styles.helpDocumentBtn}
              type="primary"
              shape="round"
            >{t('t6', '帮助文档')}</Button>
          </Tooltip>
        </a>
      </Access>

      <MenuSearch
        fontSize={18}
        options={searchedMenus}
        onSelect={(value) => {
          history.push(value)
        }}
        onChange={(searchText) => {
          if (searchText) {
            setSearchedMenus(
              initialState.flatMenus
                ?.filter((m) => m.hideInMenu !== true)
                .filter(
                  (m) =>
                    !(
                      m.children &&
                      m.children.some((c) => c.hideInMenu !== true)
                    ),
                )
                .filter((m) => m.name?.includes(searchText))
                .map((m) => ({
                  label: m.name as string,
                  value: m.path as string,
                })),
            )
          }
        }}
      />
      <Access accessible={access['call-phone']}>
        <DoubleCallModal>
          <PhoneOutlined className={styles.phoneIcon} rotate={90} />
        </DoubleCallModal>
      </Access>
      <MessageNotice />
      <MessageCenter />
      <InquiryDropdown />
      <AvatarDropdown  setUserUpdateVisible={setUserUpdateVisible} />


      {/* 国际化多语言 locales */}
      <SelectLang  onItemClick={handleItemClick}/>

      {/* 修改国际化多语言 */}
      <Access accessible={access['hm-locales_config']}>
        <LocaleModifyComp
          initIntlSucceed={initIntlSucceed}
          setInitIntlSucceed={setInitIntlSucceed}
          updateIntlMessages={updateIntlMessages}
        />
      </Access>

      {/* 点击修改个人信息 */}
      <ModalForm
        formRef={formRef}
        title={t('t7', "修改个人信息")}
        layout="horizontal"
        labelCol={{ span: 10 }}
        wrapperCol={{ span: 12 }}
        open={userUpdateVisible}
        onOpenChange={flg => {
          if (flg) {
            formRef.current?.resetFields();
            formRef.current?.validateFields(['mobile'])
          }
          setUserUpdateVisible(flg)
        }}

        initialValues={initialValues}
        onFinish={async (values) => {
          try {
            if (avatarFile) {
              message.loading(t('t8', '上传中'), 0)
              const res = await uploadFile({ path: FILE_PATH.AVATAR_PIC, file: avatarFile })
              const { code, data } = res
              message.destroy()
              if (code === 200) {
                message.success(t('t9', '上传成功'))
                values.avatarUrl = data
              }
            }
          } catch (e) {
            message.destroy()
            message.error(t('t10', '上传失败，请稍后重试'))
          }
          const { areaCode, mobile } = values
          values.mobile = areaCode=='86'?mobile:areaCode+'-'+mobile
          const success = await handleUpdateUser({
            ...values as UserFormParams,
            id: initialState?.currentUser?.id as (string | number),
            roleId: initialState?.currentUser?.roleSummary?.id as string,
          })
          if (success) {
            setUserUpdateVisible(false)
            formRef?.current?.resetFields()
          }
        }}
      >
        <Space align="start">
          <div style={{ width: 480 }}>
            <ProFormText
              width={240}
              name="name"
              fieldProps={{
                maxLength: 25,
              }}
              label={t('t11', "员工姓名")}
              rules={[{ required: true, message: t('t12', '请输入姓名！') },
                {validator:(rule: any,value: string)=>{
                    const reg=/[^\u4e00-\u9fa5a-zA-Z\s]/g;

                    if(value&&reg.test(value)){
                      return Promise.reject(rule.field+'格式不符合')
                    }
                    return Promise.resolve()
                  },message:c('common.user.name','支持：中文，英文字母，空格')}
              ]}
            />
            <ProFormText
              width={240}
              name="account"
              fieldProps={{
                maxLength: 30,
              }}
              label={t('t13', "登录名")}
              rules={[{ required: true, message: t('t14', '请输入登录名！') },
                {validator:(rule: any,value: string)=>{
                    const reg=/[^a-zA-Z/0-9]/g;

                    if(value&&reg.test(value)){
                      return Promise.reject(rule.field+'格式不符合')
                    }
                    return Promise.resolve()
                  },message:c('common.user.account','支持：字母，数字')}

              ]}
            />
            {/* <ProFormText
              width={240}
              name="mobile"
              label={t('t15', "联系电话")}
              rules={[{
                required: true,
                message: t('t16', '请输入正确的手机/固话号码！'),
                pattern: /^((0\d{2,3}-?\d{7,8})|(1[3465789]\d{9}))$/
              }]}
            /> */}
            <ProForm.Item
              style={{ marginBottom: 0 }}
              label={t('t29', "联系电话")}
              required
              tooltip={ areaCode == '86' ? (
                <div>
                  {t('t44','请输入正确的手机号码或固定电话，固定电话格式为“区号+号码”')}<br/>
                  {t('t45','如01088888888，中间无需标点符号连接。')}
                </div>
                ) : null
              }
            >
              <FormItem
                name="areaCode"
                style={{ display: 'inline-block', width: '32%' }}
              >
                <Select
                  onChange={() => {
                    setAreaCode(formRef.current?.getFieldValue('areaCode'))
                    formRef.current?.validateFields(['mobile'])
                  }}
                  options={areaCodeList}
                />
              </FormItem>
              <FormItem
                name="mobile"
                style={{ display: 'inline-block', width: 'calc(68% - 8px)', marginLeft: '8px' }}
                // rules={[
                //   () => ({ validator: mobileValidatorEdit })
                // ]}
                >
                <Input allowClear type={"number"} maxLength={11} placeholder={t('t46','请输入' )} suffix= {mobileSuffix} />
              </FormItem>
            </ProForm.Item>
          </div>
          <ProForm.Item>
            {
              avatarTempUrl || initialState?.currentUser?.avatarUrl ? (
              <Avatar
                size={104}
                shape="square"
                style={{ border: '1px dashed rgba(0, 0, 0, 0.15)', marginBottom: 12 }}
                src={avatarTempUrl || initialState?.currentUser?.avatarUrl}
              />
            ) : null}
            <Upload
              accept="image/*"
              name="avatarUrl"
              listType={avatarTempUrl || initialState?.currentUser?.avatarUrl ? 'text' : 'picture-card'}
              showUploadList={false}
              beforeUpload={file => {
                const url = window.URL.createObjectURL(file)
                setAvatarFile(file)
                setAvatarTempUrl(url)
                return false
              }}
            >
              {
                avatarTempUrl || initialState?.currentUser?.avatarUrl
                  ? <Button icon={<UploadOutlined />}>{t('t17', '更换头像')}</Button>
                  : <div>
                      <PlusOutlined />
                      <div style={{ marginTop: 8 }}>{t('t18', '上传照片')}</div>
                    </div>
              }
            </Upload>
          </ProForm.Item>
        </Space>
      </ModalForm>

      {/* 点击修改密码 */}
      <Modal
        title={t('t19', "修改密码")}
        open={!!pwdRestVisible}
        onOk={async () => {
          if (inputPassword) {
            if (!pwdPattern.test(inputPassword)) {
              message.warning(t('t20', '请设置正确的密码格式！'));
              return;
            }

          } else {
            message.warn(t('t21', '请输入新密码！'))
          }
        }}
        onCancel={async () => {
          setPwdRestVisible(false)
          setInputPassword('')
        }}
      >
        <Input.Password
          value={inputPassword}
          onChange={e => setInputPassword(e.target.value)}
          placeholder={t('t22', "请输入新密码")}
          iconRender={visible => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
        />
        <Input.Password
          value={inputPassword}
          onChange={e => setInputPassword(e.target.value)}
          placeholder={t('t22', "请输入新密码")}
          iconRender={visible => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
        />
        <Input.Password
          value={inputPassword}
          onChange={e => setInputPassword(e.target.value)}
          placeholder={t('t22', "请输入新密码")}
          iconRender={visible => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
        />
        <Typography.Text style={{ display: 'block', marginTop: 16 }}>
          {t('t23', '注：密码长度需大于6位（含），支持输入字母、数字和字符，且必须包含2项以上。设置成功后需重新登录。')}
        </Typography.Text>
      </Modal>

    
    </Space>
  )
}

// export default GlobalHeaderRight;
export default connect(mapToLocationStateProps)(GlobalHeaderRight);
